import React from "react";
import '../../assets/css/skeleton.scss'

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        } 
    }

    render() {
        return (
            <div className="skeleton">
                <div style={{width:122,height:22,marginRight:10,marginBottom:20,float:"left"}}/>
                <div style={{width:22,height:22,marginBottom:20,float:'left'}}/>
                <div className="div"/>
                <div style={{width:253,height:82,marginRight:10,borderRadius:10,backgroundColor:"#292B2F",float:"left",padding:"0 13px"}} 
                     className="table">
                    <div className="middle">
                        <div style={{width:46,height:46,marginRight:10,float:"left"}}/>
                        <div style={{width:170,height:20,marginBottom:10,float:"left"}}/>
                        <div style={{width:140,height:16,float:"left"}}/>
                    </div>
                </div>
                <div style={{width:253,height:82,marginRight:16,borderRadius:10,backgroundColor:"#292B2F",float:"left",padding:"0 13px"}} 
                     className="table">
                    <div className="middle">
                        <div style={{width:46,height:46,marginRight:10,float:"left"}}/>
                        <div style={{width:170,height:20,marginBottom:10,float:"left"}}/>
                        <div style={{width:140,height:16,float:"left"}}/>
                    </div>
                </div>
                <div className="div" style={{marginBottom:55}}/>
                <div style={{width:122,height:22,marginRight:16,marginBottom:20,float:"left"}}/>
                <div style={{width:22,height:22,marginBottom:20,float:'left'}}/>
                <div className="div"/>

                <div style={{width:253,height:132,marginRight:16,borderRadius:10,backgroundColor:"#292B2F",float:"left",padding:"0 9px", marginBottom:16}} 
                     className="table">
                    <div className="middle">
                        <div style={{width:80,height:80,marginRight:7,float:"left"}}/>
                        <div style={{width:24,height:24,marginBottom:8,float:"right",marginTop:-15}}/>
                        <div style={{width:147,height:20,marginBottom:10,float:"left"}}/>
                        <div style={{width:114,height:18,float:"left"}}/>
                    </div>
                </div>
                <div style={{width:253,height:132,marginRight:16,borderRadius:10,backgroundColor:"#292B2F",float:"left",padding:"0 9px", marginBottom:16}} 
                     className="table">
                    <div className="middle">
                        <div style={{width:80,height:80,marginRight:7,float:"left"}}/>
                        <div style={{width:24,height:24,marginBottom:8,float:"right",marginTop:-15}}/>
                        <div style={{width:147,height:20,marginBottom:10,float:"left"}}/>
                        <div style={{width:114,height:18,float:"left"}}/>
                    </div>
                </div>
                <div style={{width:253,height:132,marginRight:16,borderRadius:10,backgroundColor:"#292B2F",float:"left",padding:"0 9px", marginBottom:16}} 
                     className="table">
                    <div className="middle">
                        <div style={{width:80,height:80,marginRight:7,float:"left"}}/>
                        <div style={{width:24,height:24,marginBottom:8,float:"right",marginTop:-15}}/>
                        <div style={{width:147,height:20,marginBottom:10,float:"left"}}/>
                        <div style={{width:114,height:18,float:"left"}}/>
                    </div>
                </div>
            </div> 
        )
    }
}

export default List;
